import { render, staticRenderFns } from "./user_menu.vue?vue&type=template&id=62ae632e&scoped=true"
import script from "./user_menu.vue?vue&type=script&lang=js"
export * from "./user_menu.vue?vue&type=script&lang=js"
import style0 from "./user_menu.vue?vue&type=style&index=0&id=62ae632e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ae632e",
  null
  
)

export default component.exports